// 智能体内置头像库：底色 + 语义图标组合
// 颜色区分大类、图标区分具体用途，涵盖行业常见智能体类型，保证快速切换时一眼可区分
// agentAvatar 存值格式：
// - 内置头像：builtin:<key> 或 builtin:<key>:<hex>
// - 上传图片：<url>
// - 上传图片 + 背景色：url:<hex>:<url>
export const AGENT_AVATAR_PREFIX = 'builtin:';
export const IMAGE_AVATAR_PREFIX = 'url:';

export const PRESET_AGENT_AVATARS = [
  // 基础能力
  { key: 'chat', name: '通用对话', bg: '#409EFF', icon: 'ChatDotRound' },
  { key: 'kb', name: '知识问答', bg: '#52C41A', icon: 'Reading' },
  { key: 'doc', name: '文档处理', bg: '#13C2C2', icon: 'Document' },
  { key: 'tool', name: '工具调用', bg: '#FA8C16', icon: 'Tools' },
  { key: 'assistant', name: '智能助手', bg: '#3F8600', icon: 'MagicStick' },
  // 内容与创作
  { key: 'write', name: '文案写作', bg: '#FA541C', icon: 'EditPen' },
  { key: 'draw', name: '绘图创作', bg: '#EB2F96', icon: 'Brush' },
  { key: 'translate', name: '翻译', bg: '#13A8A8', icon: 'ChatLineSquare' },
  { key: 'video', name: '视频处理', bg: '#389E0D', icon: 'VideoCamera' },
  { key: 'voice', name: '语音识别', bg: '#9254DE', icon: 'Microphone' },
  { key: 'vision', name: '图像识别', bg: '#F759AB', icon: 'Picture' },
  // 行业与专业
  { key: 'code', name: '编程开发', bg: '#2F54EB', icon: 'Monitor' },
  { key: 'data', name: '数据分析', bg: '#F5222D', icon: 'TrendCharts' },
  { key: 'finance', name: '财务报销', bg: '#F6C343', icon: 'Money' },
  { key: 'hr', name: '人事行政', bg: '#597EF7', icon: 'Avatar' },
  { key: 'marketing', name: '营销推广', bg: '#FF7A45', icon: 'Promotion' },
  { key: 'education', name: '教育培训', bg: '#73D13D', icon: 'Notebook' },
  { key: 'medical', name: '医疗健康', bg: '#FF4D4F', icon: 'FirstAidKit' },
  { key: 'logistics', name: '物流运输', bg: '#FFC53D', icon: 'Van' },
  // 平台与支撑
  { key: 'service', name: '智能客服', bg: '#36CFC9', icon: 'Headset' },
  { key: 'review', name: '内容审核', bg: '#722ED1', icon: 'Aim' },
  { key: 'iot', name: '物联网应用', bg: '#08979C', icon: 'Connection' },
  { key: 'security', name: '安全防护', bg: '#7B61FF', icon: 'Lock' },
  { key: 'ops', name: '运维监控', bg: '#36A2EB', icon: 'Cpu' }
];

// 内置头像可选底色色板（Element Plus 风格），用于自定义颜色
export const AVATAR_COLOR_PALETTE = [
  '409EFF', '52C41A', '13C2C2', 'FA8C16', '722ED1', '36CFC9',
  'F5222D', 'EB2F96', '2F54EB', '13A8A8', 'FA541C', '389E0D',
  '9254DE', 'F759AB', 'FF7A45', '597EF7', 'F6C343', '73D13D',
  'FF4D4F', 'FFC53D', '08979C', '7B61FF', '36A2EB', '3F8600'
];

// 生成内置头像存库值
export function builtinAvatarValue(key) {
  return AGENT_AVATAR_PREFIX + key;
}

// 生成带自定义底色的内置头像存库值（hex 不带 #）
export function builtinAvatarValueWithColor(key, hex) {
  return AGENT_AVATAR_PREFIX + key + ':' + hex;
}

// 生成带背景色的图片头像存库值：url:<hex>:<url>（hex 不带 #）
export function imageAvatarValueWithColor(url, hex) {
  return IMAGE_AVATAR_PREFIX + hex + ':' + url;
}

// 解析 agentAvatar 值：
// - 内置标识 builtin:<key>、builtin:<key>:<hex> 或 builtin:<key>:transparent，返回 { type:'builtin', key, name, icon, bg }
// - 图片带背景色 url:<hex>:<url>，返回 { type:'image', url, bg }
// - 其他值返回 null（按普通图片 URL 处理）
export function parseAgentAvatar(value) {
  if (!value || typeof value !== 'string') return null;
  if (value.startsWith(IMAGE_AVATAR_PREFIX)) {
    const rest = value.slice(IMAGE_AVATAR_PREFIX.length);
    const sep = rest.indexOf(':');
    const hex = sep > -1 ? rest.slice(0, sep) : '';
    const url = sep > -1 ? rest.slice(sep + 1) : rest;
    if (/^[0-9a-fA-F]{6}$/.test(hex) && url) {
      return { type: 'image', url, bg: '#' + hex };
    }
    return null;
  }
  if (!value.startsWith(AGENT_AVATAR_PREFIX)) return null;
  const parts = value.slice(AGENT_AVATAR_PREFIX.length).split(':');
  const preset = PRESET_AGENT_AVATARS.find((a) => a.key === parts[0]);
  if (!preset) return null;
  let bg = preset.bg;
  if (parts.length > 1) {
    if (/^[0-9a-fA-F]{6}$/.test(parts[1])) {
      bg = '#' + parts[1];
    } else if (parts[1] === 'transparent') {
      bg = 'transparent';
    }
  }
  return { ...preset, type: 'builtin', bg };
}
